export const listchampsclient ={'lastname':'Nom du titulaire','firstname':'Prénom du titulaire',
    'email':'Email du titulaire','contractNumber': 'Numéro de contrat',
    "echeancePrincipale" : "Echéance Principale" ,
    "nouvelAssureur" : "Nouvel assureur",
    'address': 'Adresse du titulaire', 'city':'Ville du titulaire',
    'postCode': 'Code Postal','addressComplement': "Complément d'adresse",
   'country':'FRANCE'}




export const  liste_motifs_jeresilie_order =[
    {
        "id": 22,
        "name": "Résiliation infra-annuelle",
        "hidden": false,
        "subscriberSendingAllowed": false,
        "newInsurerNeeded": true,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": true,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": false,
        "lonelyReason": true,
        "cancellationType": "RIA",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 12,
        "name": "Echéance principale",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 10,
        "name": "Loi Châtel : Application de l'article L.113-15-1 du Code des Assurances et L221-10-1 du Code de la Mutualité",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 1,
        "name": "Changement de domicile",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 28,
        "name": "Rétractation",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "RETRACTATION",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 2,
        "name": "Changement de régime matrimonial",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 3,
        "name": "Changement de situation matrimoniale",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 4,
        "name": "Changement de profession",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 5,
        "name": "Retraite professionnelle",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 6,
        "name": "Cessation d'activité professionnelle",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 7,
        "name": "Augmentation de votre tarif",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 8,
        "name": "Décès de l'assuré ou vente d'un bien autre qu'un véhicule",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 14,
        "name": "Changement de domicile professionnel",
        "hidden": false,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 18,
        "name": "Rétractation",
        "hidden": true,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "RETRACTATION",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 19,
        "name": "Rétractation",
        "hidden": true,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "RETRACTATION",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 20,
        "name": "Augmentation Collective",
        "hidden": true,
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": true,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    },
    {
        "id": 11,
        "name": "Motif de résiliation personnalisé",
        "hidden": false,
        "identifier": "CUSTOM",
        "subscriberSendingAllowed": true,
        "newInsurerNeeded": false,
        "newContractNumberNeeded": false,
        "recuperationDateNeeded": false,
        "freeRecuperationDateMode": false,
        "echeancePrincipaleNeeded": false,
        "lonelyReason": false,
        "cancellationType": "CLASSIC",
        "loanSubscriptionDateNeeded": false
    }
]




export const liste_compagnies_jeresilie_order =
[
    {
        "id": 476,
        "companyKind": "INSURER",
        "name": "ACE EUROPEAN GROUP LIMITED",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 477,
        "companyKind": "INSURER",
        "name": "ACOMMEASSURE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 478,
        "companyKind": "INSURER",
        "name": "ACTE IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 479,
        "companyKind": "INSURER",
        "name": "ACTIVE ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 480,
        "companyKind": "INSURER",
        "name": "AFI.ESCA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 481,
        "companyKind": "INSURER",
        "name": "AFI.ESCA IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 482,
        "companyKind": "INSURER",
        "searchNames": [
            "AG2R LA MONDIALE"
        ],
        "name": "AG2R",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 484,
        "companyKind": "INSURER",
        "name": "AGEAS France",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 485,
        "companyKind": "INSURER",
        "name": "ALLIANZ IARD S.A.",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 486,
        "companyKind": "INSURER",
        "name": "AIG EUROPE LIMITED",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 487,
        "companyKind": "INSURER",
        "searchNames": [
            "TOYOTA ASSURANCES"
        ],
        "name": "AIOI NISSAY DOWA EUROPE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 488,
        "companyKind": "INSURER",
        "name": "ALBINGIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 489,
        "companyKind": "INSURER",
        "name": "ALLIANZ GLOBAL CORPORATE & SPECIALITY",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 490,
        "companyKind": "INSURER",
        "name": "ALLSECUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 491,
        "companyKind": "INSURER",
        "name": "ALOA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 492,
        "companyKind": "INSURER",
        "name": "ALPTIS ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 496,
        "companyKind": "INSURER",
        "name": "AMV",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 497,
        "companyKind": "INSURER",
        "name": "APICIL PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 499,
        "companyKind": "INSURER",
        "name": "ARCALIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 500,
        "companyKind": "INSURER",
        "name": "AREAS DOMMAGES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 501,
        "companyKind": "INSURER",
        "name": "ARIAL ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 503,
        "companyKind": "INSURER",
        "searchNames": [
            "Assu2000"
        ],
        "name": "ASSU2000",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 505,
        "companyKind": "INSURER",
        "name": "ASSURANCE MUTUELLE D OUTRE MER",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 506,
        "companyKind": "INSURER",
        "searchNames": [
            "A.C.M.",
            "C.I.C.",
            "credit mutuel"
        ],
        "name": "ACM - ASSURANCES DU CREDIT MUTUEL IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 508,
        "companyKind": "INSURER",
        "name": "ASSURONLINE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 510,
        "companyKind": "INSURER",
        "name": "AUXIA SA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 511,
        "companyKind": "INSURER",
        "name": "AVANSSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 512,
        "companyKind": "INSURER",
        "name": "AVIP ASSURANCE VIE ET PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 513,
        "companyKind": "INSURER",
        "name": "ABEILLE IARD & SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 514,
        "companyKind": "INSURER",
        "name": "AXA FRANCE IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 516,
        "companyKind": "INSURER",
        "name": "AXERIA IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 519,
        "companyKind": "INSURER",
        "name": "BNP PARIBAS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 521,
        "companyKind": "INSURER",
        "searchNames": [
            "CAISSE D'EPARGNE",
            "Banque populaire"
        ],
        "name": "BPCE ASSURANCES IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 523,
        "companyKind": "INSURER",
        "name": "CALYPSO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 524,
        "companyKind": "INSURER",
        "name": "CAMEIC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 525,
        "companyKind": "INSURER",
        "name": "CARDIF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 526,
        "companyKind": "INSURER",
        "name": "CARMA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 527,
        "companyKind": "INSURER",
        "name": "CARREFOUR ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 528,
        "companyKind": "INSURER",
        "name": "CEGEMA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 529,
        "companyKind": "INSURER",
        "name": "CETELEM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 530,
        "companyKind": "INSURER",
        "name": "CFDP ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 531,
        "companyKind": "INSURER",
        "name": "CGPA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 532,
        "companyKind": "INSURER",
        "name": "CHUBB INSURANCE COMPAGNY",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 534,
        "companyKind": "INSURER",
        "name": "CNA INSURANCE COMPANY",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 535,
        "companyKind": "INSURER",
        "name": "CNP",
        "mandatOnly": true,
        "sendMethod": "LRE"
    },
    {
        "id": 536,
        "companyKind": "INSURER",
        "name": "COFACE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 538,
        "companyKind": "INSURER",
        "searchNames": [
            "COMPAGNIE EUROPEENNE DE GARANTIES ET CAUTIONS"
        ],
        "name": "CEGC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 539,
        "companyKind": "INSURER",
        "name": "COMPAGNIE NANTAISE D ASSURANCE MARITIMES ET TERRESTRES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 540,
        "companyKind": "INSURER",
        "name": "MMA ENTREPRISE (EX COVEA RISKS)",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 545,
        "companyKind": "INSURER",
        "name": "DIRECT ASSURANCES VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 548,
        "companyKind": "INSURER",
        "name": "ECA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 551,
        "companyKind": "INSURER",
        "name": "EULER HERMES France",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 553,
        "companyKind": "INSURER",
        "searchNames": [
            "euroassurance"
        ],
        "name": "EURO-ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 554,
        "companyKind": "INSURER",
        "name": "EUROFIL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 556,
        "companyKind": "INSURER",
        "name": "FIDELIDADE COMPANHIA DE SEGUROS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 557,
        "companyKind": "INSURER",
        "name": "FINAREF RISQUES DIVERS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 558,
        "companyKind": "INSURER",
        "name": "France MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 559,
        "companyKind": "INSURER",
        "name": "GALIAN ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 561,
        "companyKind": "INSURER",
        "name": "GAN ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 563,
        "companyKind": "INSURER",
        "name": "GENERALI IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 564,
        "companyKind": "INSURER",
        "name": "GENERATION VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 565,
        "companyKind": "INSURER",
        "name": "GFA CARAIBES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 566,
        "companyKind": "INSURER",
        "name": "GMF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 568,
        "companyKind": "INSURER",
        "searchNames": [
            "Groupe Pasteur Mutualite"
        ],
        "name": "GPM ASSURANCES SA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 570,
        "companyKind": "INSURER",
        "name": "GROUPEMENT Français DE CAUTION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 571,
        "companyKind": "INSURER",
        "name": "HARMONIE Mutuelle",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 572,
        "companyKind": "INSURER",
        "name": "HDI GLOBAL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 573,
        "companyKind": "INSURER",
        "name": "HELIUM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 574,
        "companyKind": "INSURER",
        "searchNames": [
            "GROUPAMA TRANSPORT"
        ],
        "name": "HELVETIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 575,
        "companyKind": "INSURER",
        "searchNames": [
            "GROUPE HENNER"
        ],
        "name": "HENNER",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 576,
        "companyKind": "INSURER",
        "name": "HISCOX SA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 577,
        "companyKind": "INSURER",
        "name": "HSBC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 581,
        "companyKind": "INSURER",
        "name": "IMPERIO ASSURANCE ET CAPITALISATION SA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 585,
        "companyKind": "INSURER",
        "name": "L'AUXILIAIRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 586,
        "companyKind": "INSURER",
        "name": "L EQUITE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 587,
        "companyKind": "INSURER",
        "name": "L ETOILE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 588,
        "companyKind": "INSURER",
        "searchNames": [
            "l'olivier",
            "L'OLIVIER ASSURANCES"
        ],
        "name": "L OLIVIER ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 589,
        "companyKind": "INSURER",
        "name": "LA BANQUE POSTALE ASSURANCES IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 591,
        "companyKind": "INSURER",
        "name": "LA MEDICALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 592,
        "companyKind": "INSURER",
        "name": "LA MONDIALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 594,
        "companyKind": "INSURER",
        "name": "MADP ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 595,
        "companyKind": "INSURER",
        "name": "LA MUTUELLE DE POITIERS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 598,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE SAINT CHRISTOPHE ASSURANCE"
        ],
        "name": "MUTUELLE SAINT CHRISTOPHE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 600,
        "companyKind": "INSURER",
        "name": "LA RURALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 601,
        "companyKind": "INSURER",
        "name": "LA SAUVEGARDE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 602,
        "companyKind": "INSURER",
        "name": "LA SECURITE FAMILIALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 603,
        "companyKind": "INSURER",
        "name": "LE CONSERVATEUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 604,
        "companyKind": "INSURER",
        "name": "LE FINISTERE ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 607,
        "companyKind": "INSURER",
        "name": "LIBERTY MUTUAL INSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 608,
        "companyKind": "INSURER",
        "name": "LLOYD S  DE LONDRES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 609,
        "companyKind": "INSURER",
        "name": "LUXIOR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 610,
        "companyKind": "INSURER",
        "name": "LYBERNET ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 611,
        "companyKind": "INSURER",
        "name": "MNH",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 612,
        "companyKind": "INSURER",
        "name": "MUTUELLE UMC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 613,
        "companyKind": "INSURER",
        "name": "MAAF Assurances",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 614,
        "companyKind": "INSURER",
        "searchNames": [
            "MACIFILIA",
            "MACIF MUTUALITE"
        ],
        "name": "MACIF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 615,
        "companyKind": "INSURER",
        "name": "MACSF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 616,
        "companyKind": "INSURER",
        "name": "MAIF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 617,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE D ASSURANCE DE LA BOULANGERIE"
        ],
        "name": "MAPA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 618,
        "companyKind": "INSURER",
        "name": "MARSH",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 619,
        "companyKind": "INSURER",
        "name": "MATMUT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 620,
        "companyKind": "INSURER",
        "name": "MAXANCE ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 621,
        "companyKind": "INSURER",
        "name": "METLIFE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 622,
        "companyKind": "INSURER",
        "searchNames": [
            "MFA"
        ],
        "name": "MUTUELLE FRATERNELLE ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 623,
        "companyKind": "INSURER",
        "name": "MILTIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 625,
        "companyKind": "INSURER",
        "name": "MMA IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 629,
        "companyKind": "INSURER",
        "name": "CARCEPT ACCIDENT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 630,
        "companyKind": "INSURER",
        "name": "MUTUELLE BLEUE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 631,
        "companyKind": "INSURER",
        "searchNames": [
            "MAVIT"
        ],
        "name": "MUTUELLE D ASSURANCE DE LA VILLE DE THANN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 634,
        "companyKind": "INSURER",
        "name": "MUTUELLE ARCHITECTES FRANCAIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 635,
        "companyKind": "INSURER",
        "name": "ASSURANCE MUTUELLE DES MOTARDS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 636,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE GENERALE DES CHEMINOTS"
        ],
        "name": "MUTUELLE MGC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 637,
        "companyKind": "INSURER",
        "name": "MUTUELLE PREVIFRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 638,
        "companyKind": "INSURER",
        "name": "NATIO ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 640,
        "companyKind": "INSURER",
        "searchNames": [
            "ORYS SANTE",
            "LINEA SANTE"
        ],
        "name": "NEOLIANE SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 641,
        "companyKind": "INSURER",
        "name": "NETVOX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 645,
        "companyKind": "INSURER",
        "name": "NOVELIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 646,
        "companyKind": "INSURER",
        "name": "OPEGA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 647,
        "companyKind": "INSURER",
        "name": "OPTEVEN ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 648,
        "companyKind": "INSURER",
        "name": "OPTIMUM VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 649,
        "companyKind": "INSURER",
        "name": "ORADEA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 650,
        "companyKind": "INSURER",
        "searchNames": [
            "L.C.L.",
            "Credit Agricole"
        ],
        "name": "PACIFICA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 651,
        "companyKind": "INSURER",
        "name": "PANACEA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 654,
        "companyKind": "INSURER",
        "name": "PLURIEL ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 655,
        "companyKind": "INSURER",
        "searchNames": [
            "Credit Agricole"
        ],
        "name": "PREDICA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 656,
        "companyKind": "INSURER",
        "name": "PREMAVALS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 657,
        "companyKind": "INSURER",
        "name": "PREPAR IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 660,
        "companyKind": "INSURER",
        "name": "PRIMA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 661,
        "companyKind": "INSURER",
        "name": "PROBTP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 662,
        "companyKind": "INSURER",
        "name": "PROTEC BTP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 663,
        "companyKind": "INSURER",
        "name": "PROTEGY'S",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 664,
        "companyKind": "INSURER",
        "name": "ALLIANZ PROTECTION JURIDIQUE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 665,
        "companyKind": "INSURER",
        "name": "PRUDENCE CREOLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 667,
        "companyKind": "INSURER",
        "name": "QBE Europe SA/NV",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 668,
        "companyKind": "INSURER",
        "name": "QUATREM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 669,
        "companyKind": "INSURER",
        "name": "REMA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 672,
        "companyKind": "INSURER",
        "searchNames": [
            "RSA FRANCE"
        ],
        "name": "RSA FRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 673,
        "companyKind": "INSURER",
        "name": "RVA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 675,
        "companyKind": "INSURER",
        "name": "SAMAP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 678,
        "companyKind": "INSURER",
        "name": "RELYENS MUTUAL INSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 680,
        "companyKind": "INSURER",
        "name": "SAGEVIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 682,
        "companyKind": "INSURER",
        "name": "SERENIS ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 684,
        "companyKind": "INSURER",
        "name": "SMAM",
        "mandatOnly": true,
        "sendMethod": "LRE"
    },
    {
        "id": 685,
        "companyKind": "INSURER",
        "name": "SMATIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 686,
        "companyKind": "INSURER",
        "name": "SOCIETE SUISSE D ASSURANCE CONTRE LA GRELE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 687,
        "companyKind": "INSURER",
        "name": "SOGECAP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 688,
        "companyKind": "INSURER",
        "name": "SOGESSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 689,
        "companyKind": "INSURER",
        "name": "SOLLY AZAR ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 690,
        "companyKind": "INSURER",
        "name": "SOLUCIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 692,
        "companyKind": "INSURER",
        "name": "SPHERIA VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 693,
        "companyKind": "INSURER",
        "name": "SPIRICA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 695,
        "companyKind": "INSURER",
        "name": "SURAVENIR ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 696,
        "companyKind": "INSURER",
        "searchNames": [
            "swisslife"
        ],
        "name": "SWISSLIFE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 698,
        "companyKind": "INSURER",
        "name": "THELEM ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 701,
        "companyKind": "INSURER",
        "name": "UNOFI",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 703,
        "companyKind": "INSURER",
        "name": "VIVENS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 704,
        "companyKind": "INSURER",
        "name": "XENASSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 706,
        "companyKind": "INSURER",
        "searchNames": [
            "groupe zephir"
        ],
        "name": "ZEPHIR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 707,
        "companyKind": "INSURER",
        "name": "ZURICH INSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 714,
        "companyKind": "INSURER",
        "name": "LA BANQUE POSTALE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 715,
        "companyKind": "INSURER",
        "name": "SMACL ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 716,
        "companyKind": "INSURER",
        "name": "PROTEXIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 717,
        "companyKind": "INSURER",
        "name": "DIRECT ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 718,
        "companyKind": "INSURER",
        "name": "Capi Finance",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 720,
        "companyKind": "INSURER",
        "name": "MGEN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 724,
        "companyKind": "INSURER",
        "name": "MONCEAU GENERALE ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 725,
        "companyKind": "INSURER",
        "name": "MUTUELLE D'ASSURANCE DE LA VILLE DE MULHOUSE - MAVIM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 728,
        "companyKind": "INSURER",
        "name": "SADA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 729,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE LOIRE FOREZ",
            "SAMIR",
            "MUTUELLE ENSEMBLE"
        ],
        "name": "ENTIS MUTUELLES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 730,
        "companyKind": "INSURER",
        "name": "PARIS ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 732,
        "companyKind": "INSURER",
        "name": "Groupe AMI3F",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 735,
        "companyKind": "INSURER",
        "name": "MGEN Filia",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 736,
        "companyKind": "INSURER",
        "searchNames": [
            "ASAF ET AFPS"
        ],
        "name": "ASAF & AFPS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 737,
        "companyKind": "INSURER",
        "name": "MGARD ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 738,
        "companyKind": "INSURER",
        "name": "APRIL PARTENAIRES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 739,
        "companyKind": "INSURER",
        "name": "APRIL IMMOBILIER",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 740,
        "companyKind": "INSURER",
        "name": "APRIL SANTE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 741,
        "companyKind": "INSURER",
        "searchNames": [
            "A.M.P",
            "AMP"
        ],
        "name": "ASSURANCES MUTUELLES DE PICARDIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 742,
        "companyKind": "INSURER",
        "searchNames": [
            "MMC"
        ],
        "name": "Mutuelle Medico Chirurgicale",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 744,
        "companyKind": "INSURER",
        "name": "UCR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 745,
        "companyKind": "INSURER",
        "name": "AMF ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 746,
        "companyKind": "INSURER",
        "name": "AGPM (Association Generale de Prevoyance Militaire)",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 747,
        "companyKind": "INSURER",
        "name": "Mutuelle Integrance",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 748,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE DU MIDI",
            "CAISSE DE PREVOYANCE MULHOUSIENNE"
        ],
        "name": "VIASANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 749,
        "companyKind": "INSURER",
        "searchNames": [
            "CAISSE D'EPARGNE",
            "Banque populaire"
        ],
        "name": "BPCE IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 751,
        "companyKind": "INSURER",
        "name": "GROUPAMA GAN VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 752,
        "companyKind": "INSURER",
        "name": "REPAM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 753,
        "companyKind": "INSURER",
        "name": "MUTUELLE UNEO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 754,
        "companyKind": "INSURER",
        "name": "OFAR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 755,
        "companyKind": "INSURER",
        "name": "CFCA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 756,
        "companyKind": "INSURER",
        "name": "ASSURANCES PILLIOT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 757,
        "companyKind": "INSURER",
        "name": "SMABTP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 758,
        "companyKind": "INSURER",
        "name": "AON FRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 759,
        "companyKind": "INSURER",
        "name": "Mutuelle Generale Sante MGS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 760,
        "companyKind": "INSURER",
        "name": "GALLIA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 761,
        "companyKind": "INSURER",
        "name": "Groupe SATEC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 762,
        "companyKind": "INSURER",
        "searchNames": [
            "AESIO",
            "AESIO MUTUELLE"
        ],
        "name": "ADREA Mutuelle",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 763,
        "companyKind": "INSURER",
        "searchNames": [
            "FB assurances",
            "Groupe francois bernard",
            "Groupe FB"
        ],
        "name": "OYAT ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 766,
        "companyKind": "INSURER",
        "searchNames": [
            "VITTAVI MUTUELLE",
            "AESIO",
            "AESIO MUTUELLE"
        ],
        "name": "EOVI MCD mutuelle",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 767,
        "companyKind": "INSURER",
        "name": "SG SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 768,
        "companyKind": "INSURER",
        "name": "IDENTITES MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 769,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE NATIONALE TERRITORIALE"
        ],
        "name": "MNT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 771,
        "companyKind": "INSURER",
        "name": "SYNERGIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 772,
        "companyKind": "INSURER",
        "name": "MATH-PREVARIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 773,
        "companyKind": "INSURER",
        "searchNames": [
            "HUMANIS MUTUELLE NATIONALE",
            "HUMANIS PREVOYANCE",
            "ETIKA"
        ],
        "name": "MALAKOFF MEDERIC HUMANIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 774,
        "companyKind": "INSURER",
        "searchNames": [
            "MIP"
        ],
        "name": "MUTUELLE MIP L ENTREPRISE SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 776,
        "companyKind": "INSURER",
        "name": "Mutuelle Mieux-Etre",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 777,
        "companyKind": "INSURER",
        "name": "RADIANCE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 778,
        "companyKind": "INSURER",
        "name": "CLC INTERNATIONAL ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 779,
        "companyKind": "INSURER",
        "name": "DIOT SA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 780,
        "companyKind": "INSURER",
        "name": "AGIPI",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 781,
        "companyKind": "INSURER",
        "name": "MUTUELLE 403",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 782,
        "companyKind": "INSURER",
        "name": "APRS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 784,
        "companyKind": "INSURER",
        "searchNames": [
            "LES MUTUELLES DU SOLEIL"
        ],
        "name": "Mutuelles du Soleil",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 785,
        "companyKind": "INSURER",
        "name": "M comme Mutuelle",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 786,
        "companyKind": "INSURER",
        "name": "Mutuelle Générale de la Police",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 787,
        "companyKind": "INSURER",
        "searchNames": [
            "CMAM",
            "C.M.A.M"
        ],
        "name": "CAISSE MEUSIENNE D'ASSURANCES MUTUELLES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 790,
        "companyKind": "INSURER",
        "name": "Assurpeople",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 793,
        "companyKind": "INSURER",
        "name": "AGEO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 794,
        "companyKind": "INSURER",
        "searchNames": [
            "La mutuelle familiale"
        ],
        "name": "MUTUELLE FAMILIALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 795,
        "companyKind": "INSURER",
        "name": "SATIS assurances",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 797,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU REMPART",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 798,
        "companyKind": "INSURER",
        "name": "CMMA Assurance",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 799,
        "companyKind": "INSURER",
        "name": "FGP ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 800,
        "companyKind": "INSURER",
        "name": "MUTUELLE OCIANE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 801,
        "companyKind": "INSURER",
        "name": "SAGESSE ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 804,
        "companyKind": "INSURER",
        "name": "GROUPAMA GRAND EST",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 805,
        "companyKind": "INSURER",
        "searchNames": [
            "mutuelle MIE"
        ],
        "name": "Mutuelle Intergroupes d’Entraide (MIE)",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 806,
        "companyKind": "INSURER",
        "name": "Willis Towers Watson France",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 807,
        "companyKind": "INSURER",
        "name": "ARCA Assurances",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 810,
        "companyKind": "INSURER",
        "name": "MHV",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 813,
        "companyKind": "INSURER",
        "name": "mutuelle GSMC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 814,
        "companyKind": "INSURER",
        "name": "MUTUELLE LA CHOLETAISE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 815,
        "companyKind": "INSURER",
        "name": "J.P. LABALETTE S.A.",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 816,
        "companyKind": "INSURER",
        "name": "LA BANQUE POSTALE ASSURANCE SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 817,
        "companyKind": "INSURER",
        "name": "ACFI SOLUTIONS IDOINES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 820,
        "companyKind": "INSURER",
        "name": "Euralpha Assurances",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 821,
        "companyKind": "INSURER",
        "name": "KOHLER  ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 822,
        "companyKind": "INSURER",
        "name": "UGIP ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 823,
        "companyKind": "INSURER",
        "name": "APRIL MARINE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 824,
        "companyKind": "INSURER",
        "searchNames": [
            "LA BRESSE"
        ],
        "name": "MUTUELLE DE L'EST",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 825,
        "companyKind": "INSURER",
        "name": "SMEREP - SMGP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 828,
        "companyKind": "INSURER",
        "name": "Alphaplus Famille Assurances",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 830,
        "companyKind": "INSURER",
        "name": "KLESIA PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 836,
        "companyKind": "INSURER",
        "name": "AXA FRANCE VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 838,
        "companyKind": "INSURER",
        "name": "Finassur",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 840,
        "companyKind": "INSURER",
        "name": "MTRL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 851,
        "companyKind": "INSURER",
        "name": "GENERALI VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 853,
        "companyKind": "INSURER",
        "name": "PAVILLON PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 856,
        "companyKind": "INSURER",
        "name": "MUTUELLE MUNICIPAUX DE MARSEILLE MUTAME PROVENCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 857,
        "companyKind": "INSURER",
        "name": "GROUPAMA CENTRE MANCHE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 858,
        "companyKind": "INSURER",
        "name": "GROUPAMA OCEAN INDIEN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 859,
        "companyKind": "INSURER",
        "name": "GROUPAMA LOIRE BRETAGNE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 860,
        "companyKind": "INSURER",
        "name": "GROUPAMA ANTILLES GUYANE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 861,
        "companyKind": "INSURER",
        "name": "GROUPAMA RHONE-ALPES AUVERGNE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 862,
        "companyKind": "INSURER",
        "name": "GROUPAMA NORD-EST",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 863,
        "companyKind": "INSURER",
        "name": "GROUPAMA PARIS VAL DE LOIRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 865,
        "companyKind": "INSURER",
        "name": "GROUPAMA MEDITERRANEE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 866,
        "companyKind": "INSURER",
        "name": "GROUPAMA CENTRE ATLANTIQUE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 868,
        "companyKind": "INSURER",
        "name": "AIR-ALPHA Assurances",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 870,
        "companyKind": "INSURER",
        "name": "FMA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 873,
        "companyKind": "INSURER",
        "name": "Mutuelle du Var Emoa",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 874,
        "companyKind": "INSURER",
        "name": "LEADER ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 875,
        "companyKind": "INSURER",
        "name": "GROUPAMA D OC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 876,
        "companyKind": "INSURER",
        "name": "ALLIANZ COURTAGE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 877,
        "companyKind": "INSURER",
        "name": "AXA COURTAGE IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 878,
        "companyKind": "INSURER",
        "name": "Verspieren",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 880,
        "companyKind": "INSURER",
        "name": "LSA COURTAGE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 882,
        "companyKind": "INSURER",
        "name": "MMA VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 883,
        "companyKind": "INSURER",
        "searchNames": [
            "mutuelle d'alsace et de lorraine jura",
            "MALJ",
            "M.A.L.J"
        ],
        "name": "MUTUELLE ALSACE LORRAINE JURA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 884,
        "companyKind": "INSURER",
        "searchNames": [
            "FFA",
            "F.F.A"
        ],
        "name": "FEDERATION FRANCAISE DES ASSURES",
        "mandatOnly": true,
        "sendMethod": "LRE"
    },
    {
        "id": 885,
        "companyKind": "INSURER",
        "name": "NATIONAL COURTAGE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 886,
        "companyKind": "INSURER",
        "name": "IPECA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 887,
        "companyKind": "INSURER",
        "name": "APIVIA MUTUELLE",
        "mandatOnly": true,
        "sendMethod": "LRE"
    },
    {
        "id": 888,
        "companyKind": "INSURER",
        "name": "EUROSUD SWATON",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 890,
        "companyKind": "INSURER",
        "name": "ASSURANCES et CONSEILS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 894,
        "companyKind": "INSURER",
        "name": "SANTE MUT ROANNE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 895,
        "companyKind": "INSURER",
        "name": "ALLIANZ VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 896,
        "companyKind": "INSURER",
        "searchNames": [
            "A.C.M.",
            "credit mutuel"
        ],
        "name": "ACM - ASSURANCES DU CREDIT MUTUEL VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 900,
        "companyKind": "INSURER",
        "name": "ACBS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 901,
        "companyKind": "INSURER",
        "name": "LIBEA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 902,
        "companyKind": "INSURER",
        "name": "EPSIL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 904,
        "companyKind": "INSURER",
        "name": "SARPGN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 909,
        "companyKind": "INSURER",
        "searchNames": [
            "AESIO",
            "AESIO MUTUELLE"
        ],
        "name": "APREVA MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 913,
        "companyKind": "INSURER",
        "searchNames": [
            "Societe Mutuelle d’Assurance de Bourgogne"
        ],
        "name": "SMAB",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 914,
        "companyKind": "INSURER",
        "name": "APGIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 916,
        "companyKind": "INSURER",
        "name": "ACORIS MUTUELLES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 918,
        "companyKind": "INSURER",
        "name": "SOLIMUT Mutuelle de France",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 920,
        "companyKind": "INSURER",
        "name": "SMENO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 923,
        "companyKind": "INSURER",
        "name": "MUTUELLE ENTRAIN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 924,
        "companyKind": "INSURER",
        "searchNames": [
            "La Mutuelle Des Etudiants"
        ],
        "name": "LMDE-MUTUELLE INTERIALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 925,
        "companyKind": "INSURER",
        "name": "+Simple.Fr",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 926,
        "companyKind": "INSURER",
        "name": "SAGA SERVICE PLUS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 928,
        "companyKind": "INSURER",
        "searchNames": [
            "MCA"
        ],
        "name": "MUTUELLE COMPLEMENTAIRE D'ALSACE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 931,
        "companyKind": "INSURER",
        "name": "MNSPF Mutuelle Nationale des Sapeurs Pompiers de France",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 932,
        "companyKind": "INSURER",
        "searchNames": [
            "MGEL",
            "MVS",
            "Mutuelle vitalite sante",
            "Mutuelle Generale des Etudiants de L'Est"
        ],
        "name": "MGEL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 933,
        "companyKind": "INSURER",
        "name": "IRCEM MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 934,
        "companyKind": "INSURER",
        "name": "AMPLI MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 935,
        "companyKind": "INSURER",
        "searchNames": [
            "M.A.A."
        ],
        "name": "Mutuelle d'Assurance des Armées",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 936,
        "companyKind": "INSURER",
        "name": "MUTUELLE D ENTREPRISES SCHNEIDER ELECTRIC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 937,
        "companyKind": "INSURER",
        "name": "UNIPREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 938,
        "companyKind": "INSURER",
        "name": "PRADO MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 943,
        "companyKind": "INSURER",
        "searchNames": [
            "S.M.I."
        ],
        "name": "SMI MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 944,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE D'AUVERGNE"
        ],
        "name": "PRECOCIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 946,
        "companyKind": "INSURER",
        "name": "APICIL MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 947,
        "companyKind": "INSURER",
        "name": "HEUX ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 948,
        "companyKind": "INSURER",
        "searchNames": [
            "UNION NATIONALE MUTUALISTE INTERPROFESSIONNELLE"
        ],
        "name": "UNMI",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 950,
        "companyKind": "INSURER",
        "name": "INTERIALE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 951,
        "companyKind": "INSURER",
        "searchNames": [
            "MBA"
        ],
        "name": "M.B.A MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 952,
        "companyKind": "INSURER",
        "name": "FILIASSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 954,
        "companyKind": "INSURER",
        "name": "525EME MUTUELLE D ENTREPRISES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 955,
        "companyKind": "INSURER",
        "name": "ALLIANCE DES MUTUALISTES DU TRANSPORT (ALMUTRA)",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 960,
        "companyKind": "INSURER",
        "name": "AVENIR MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 961,
        "companyKind": "INSURER",
        "name": "MUTUELLE AVENIR SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 962,
        "companyKind": "INSURER",
        "name": "AVENIR SANTE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 964,
        "companyKind": "INSURER",
        "name": "BPCE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 972,
        "companyKind": "INSURER",
        "searchNames": [
            "CNM PREVOYANCE SANTE",
            "C.N.M"
        ],
        "name": "CNM PREVOYANCE SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 975,
        "companyKind": "INSURER",
        "searchNames": [
            "cmip"
        ],
        "name": "CENTRE MUTUALISTE INTERPROFESSIONNEL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 993,
        "companyKind": "INSURER",
        "name": "IRP AUTO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 994,
        "companyKind": "INSURER",
        "name": "KLESIA MUT'",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1000,
        "companyKind": "INSURER",
        "name": "LA FRANCE MUTUALISTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1008,
        "companyKind": "INSURER",
        "name": "LA MUTUELLE GENERALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1010,
        "companyKind": "INSURER",
        "name": "LA MUTUELLE VERTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1011,
        "companyKind": "INSURER",
        "name": "LA PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1016,
        "companyKind": "INSURER",
        "name": "LE REFUGE MUTUALISTE AVEYRONNAIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1020,
        "companyKind": "INSURER",
        "name": "LES MUTUELLES LIGERIENNES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1024,
        "companyKind": "INSURER",
        "name": "MAAF SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1038,
        "companyKind": "INSURER",
        "name": "MUTEST",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1040,
        "companyKind": "INSURER",
        "name": "MUTAERO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1043,
        "companyKind": "INSURER",
        "name": "MUTAMI",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1046,
        "companyKind": "INSURER",
        "name": "MUTEX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1052,
        "companyKind": "INSURER",
        "name": "MUTUALIA GRAND OUEST",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1053,
        "companyKind": "INSURER",
        "name": "MUTUALIA ALLIANCE SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1065,
        "companyKind": "INSURER",
        "name": "MUTUELLE ACTIVE DES ORGANISMES SOCIAUX ET DIVERS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1069,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTA SANTE"
        ],
        "name": "MUTUELLE ALSACIENNE POUR LA SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1073,
        "companyKind": "INSURER",
        "searchNames": [
            "MAGE"
        ],
        "name": "MUTUELLE AUTONOME GENERALE EDUCATION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1078,
        "companyKind": "INSURER",
        "name": "MUTUELLE CENTRALE DES FINANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1079,
        "companyKind": "INSURER",
        "name": "MUTUELLE CHEMINOTS NORD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1082,
        "companyKind": "INSURER",
        "name": "MUTUELLE CITRAM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1083,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE CIVILE DE LA DEFENSE"
        ],
        "name": "MCDEF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1087,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE COMPLEMENTAIRE DE LA VILLE DE PARIS DE L ASSISTANCE PUBLIQUE ET DES ADMINISTRATIONS ANNEXES",
            "MC602"
        ],
        "name": "MCVPAP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1092,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE D ARGENSON ET DES FONCTIONNAIRES DE L ENSEIGNEMENT PUBLIC"
        ],
        "name": "MUTUELLE ARGENSON",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1102,
        "companyKind": "INSURER",
        "searchNames": [
            "M.I.F.",
            "MUTUELLE D'IVRY LA FRATERNELLE"
        ],
        "name": "MIF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1106,
        "companyKind": "INSURER",
        "name": "MUTUELLE DE FRANCE ALPES DU SUD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1108,
        "companyKind": "INSURER",
        "searchNames": [
            "MFH"
        ],
        "name": "MUTUELLE DE FRANCE DES HOSPITALIERS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1114,
        "companyKind": "INSURER",
        "searchNames": [
            "M SANTE MUTUELLE FAMILIALE",
            "MUTUELLE SANTE 08"
        ],
        "name": "MUTUELLE DE FRANCE UNIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1127,
        "companyKind": "INSURER",
        "name": "MUTUELLE DE LA MEDITERRANEE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1129,
        "companyKind": "INSURER",
        "name": "MUTUELLE DE LA POLICE NATIONALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1134,
        "companyKind": "INSURER",
        "name": "MUTUELLE DE PONTOISE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1135,
        "companyKind": "INSURER",
        "name": "MUTAC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1138,
        "companyKind": "INSURER",
        "searchNames": [
            "MPI"
        ],
        "name": "MUTUELLE DE PREVOYANCE INTERPROFESSIONNELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1147,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES ASSURES SOCIAUX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1150,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES CHAMBRES DE COMMERCE ET D INDUSTRIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1152,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES CHEMINOTS DE LA REGION DE NANTES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1155,
        "companyKind": "INSURER",
        "searchNames": [
            "MCEN"
        ],
        "name": "MUTUELLE DES CLERCS ET EMPLOYES DE NOTAIRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1171,
        "companyKind": "INSURER",
        "name": "MUTUELLE SMH",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1173,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE DES INDUSTRIES AERONAUTIQUES SPATIALES ET CONNEXES"
        ],
        "name": "MUTUELLE MIASC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1175,
        "companyKind": "INSURER",
        "name": "ENERGIE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1180,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES PAYS DE VAUCLUSE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1181,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES PAYS DE VILAINE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1190,
        "companyKind": "INSURER",
        "searchNames": [
            "mspp"
        ],
        "name": "MUTUELLE DES SAPEURS POMPIERS DE PARIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1194,
        "companyKind": "INSURER",
        "searchNames": [
            "MSP"
        ],
        "name": "MUTUELLE DES SERVICES PUBLICS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1196,
        "companyKind": "INSURER",
        "searchNames": [
            "MTH"
        ],
        "name": "MUTUELLE DES TERRITORIAUX ET HOSPITALIERS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1205,
        "companyKind": "INSURER",
        "name": "ASPBTP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1207,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE DU BATIMENT ET DES TRAVAUX PUBLICS DU SUD EST ET DES REGIONS DE FRANCE",
            "MUTUELLE MBTP"
        ],
        "name": "MBTP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1208,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU CHAMPAGNE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1209,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU CHU ET HOPITAUX DU PUY DE DOME",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1213,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU GROUPE BNP PARIBAS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1218,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU PAYS MARTEGAL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1237,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU PERSONNEL DU GROUPE RATP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1242,
        "companyKind": "INSURER",
        "searchNames": [
            "Mutuelle du personnel IBM"
        ],
        "name": "MUTUELLE NUOMA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1243,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES PERSONNELS MARITIMES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1251,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU VAL DE SEVRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1258,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE FAMILIALE DE L ILE DE FRANCE"
        ],
        "name": "MFIF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1263,
        "companyKind": "INSURER",
        "name": "MUTUELLE FAMILIALE DE NORMANDIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1265,
        "companyKind": "INSURER",
        "name": "MUTUELLE FAMILIALE DES CHEMINOTS DE FRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1274,
        "companyKind": "INSURER",
        "searchNames": [
            "MGA"
        ],
        "name": "MUTUELLE GENERALE D AVIGNON",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1282,
        "companyKind": "INSURER",
        "name": "MUTUELLE GENERALE DE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1284,
        "companyKind": "INSURER",
        "searchNames": [
            "MGPS"
        ],
        "name": "MUTUELLE GENERALE DE PREVOYANCE SOCIALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1285,
        "companyKind": "INSURER",
        "searchNames": [
            "MGAS"
        ],
        "name": "MUTUELLE GENERALE DES AFFAIRES SOCIALES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1290,
        "companyKind": "INSURER",
        "name": "MUTUELLE GENERALE INTERPROFESSIONNELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1302,
        "companyKind": "INSURER",
        "name": "MUTUELLE INTERPROFESSIONNELLE DES ORGANISMES SOCIAUX - MIPOS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1306,
        "companyKind": "INSURER",
        "searchNames": [
            "MIPSS AUVERGNE"
        ],
        "name": "MIPSS AUVERGNE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1311,
        "companyKind": "INSURER",
        "name": "MUTUELLE INTERPROFESSIONNELLE ANTILLES GUYANE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1312,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE MIP"
        ],
        "name": "MUTUELLE INTERPROFESSIONNELLE DE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1314,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE INTERPROFESSIONNELLE LES MENAGES PREVOYANTS",
            "LMP"
        ],
        "name": "LES MENAGES PREVOYANTS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1318,
        "companyKind": "INSURER",
        "name": "MUTUELLE JUST",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1330,
        "companyKind": "INSURER",
        "name": "CHORALIS MUTUELLE LE LIBRE CHOIX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1348,
        "companyKind": "INSURER",
        "searchNames": [
            "MNPAF"
        ],
        "name": "MUTUELLE NATIONALE DES PERSONNELS AIR FRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1350,
        "companyKind": "INSURER",
        "searchNames": [
            "M.N.P.E.M."
        ],
        "name": "MUTUELLE NATIONALE DU PERSONNEL DES ETABLISSEMENTS MICHELIN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1359,
        "companyKind": "INSURER",
        "name": "MUTUELLE PROVENCE ENTREPRISES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1360,
        "companyKind": "INSURER",
        "searchNames": [
            "muros"
        ],
        "name": "MUTUELLE REGIONALE DES ORGANISMES SOCIAUX DU CENTRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1361,
        "companyKind": "INSURER",
        "name": "MUTUELLE RENAULT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1362,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE SAINT GOBAIN ET ASSIMILES"
        ],
        "name": "MUTUELLE VERRIERS ET ASSIMILES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1363,
        "companyKind": "INSURER",
        "searchNames": [
            "Mutuelle MSM"
        ],
        "name": "MUTUELLE SAINT MARTIN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1365,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE KLESIA SAINT-GERMAIN"
        ],
        "name": "MUTUELLE SAINT-GERMAIN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1370,
        "companyKind": "INSURER",
        "name": "MUTUELLE SANTE EIFFAGE ENERGIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1378,
        "companyKind": "INSURER",
        "name": "MUTUELLE VALEO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1381,
        "companyKind": "INSURER",
        "name": "MUTUELLE VICTOR HUGO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1383,
        "companyKind": "INSURER",
        "name": "MUTUELLES DU PAYS HAUT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1390,
        "companyKind": "INSURER",
        "name": "PREVOYANCE MUTUALISTE D ILE DE FRANCE - MUTUELLE PMIF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1392,
        "companyKind": "INSURER",
        "name": "REUNICA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1396,
        "companyKind": "INSURER",
        "name": "SEREINA MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1400,
        "companyKind": "INSURER",
        "searchNames": [
            "SO LYON MUTUELLE"
        ],
        "name": "SO'LYON MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1405,
        "companyKind": "INSURER",
        "name": "SIMIRP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1408,
        "companyKind": "INSURER",
        "searchNames": [
            "SOCIETE MUTUALISTE DE LA SOCIETE EUROPEENNE DES PRODUITS REFRACTAIRES"
        ],
        "name": "SOCIETE MUTUALISTE SEPR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1415,
        "companyKind": "INSURER",
        "searchNames": [
            "S.M.P.S",
            "SMPS"
        ],
        "name": "SOCIETE MUTUALISTE DU PERSONNEL DE LA SNECMA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1416,
        "companyKind": "INSURER",
        "searchNames": [
            "SOCIETE MUTUALISTE DU PERSONNEL DU GROUPE MMA ET SES FILIALES"
        ],
        "name": "NYMPHEA SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1435,
        "companyKind": "INSURER",
        "name": "SOLIMUT MUTUELLE PERSONNELS ORGANISMES SOCIAUX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1439,
        "companyKind": "INSURER",
        "name": "UNIMUTUELLES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1458,
        "companyKind": "INSURER",
        "name": "MUTUELLE UNITE FRATERNELLE DES REGIONS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1462,
        "companyKind": "INSURER",
        "name": "POP SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1466,
        "companyKind": "INSURER",
        "searchNames": [
            "Mutuelle Generale de la Distribution"
        ],
        "name": "MGD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1467,
        "companyKind": "INSURER",
        "searchNames": [
            "CENTRE GESTION REGLEMENTS MALADIE"
        ],
        "name": "CGRM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1469,
        "companyKind": "INSURER",
        "name": "CCMO MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1470,
        "companyKind": "INSURER",
        "name": "AFI ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1471,
        "companyKind": "INSURER",
        "name": "ARPEGE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1472,
        "companyKind": "INSURER",
        "searchNames": [
            "CAISSE D'ASSURANCE MUTUELLE DU BATIMENT ET DES TRAVAUX PUBLICS",
            "CAM BTP"
        ],
        "name": "CAMACTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1475,
        "companyKind": "INSURER",
        "name": "ASSUREO",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1476,
        "companyKind": "INSURER",
        "name": "MUTUALE LA MUTUELLE FAMILIALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1478,
        "companyKind": "INSURER",
        "searchNames": [
            "Franche-Comte Assurance"
        ],
        "name": "I2FC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1479,
        "companyKind": "INSURER",
        "searchNames": [
            "MMJ"
        ],
        "name": "MUTUELLE DU MINISTERE DE LA JUSTICE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1483,
        "companyKind": "INSURER",
        "name": "GROUPE PROASSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1486,
        "companyKind": "INSURER",
        "searchNames": [
            "NOVAMUT MUTUELLE"
        ],
        "name": "GROUPE NOVAMUT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1490,
        "companyKind": "INSURER",
        "name": "MUTUELLE CARCEPT PREV",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1492,
        "companyKind": "INSURER",
        "name": "ADP COURTAGE PLUS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1494,
        "companyKind": "INSURER",
        "name": "UNIM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1496,
        "companyKind": "INSURER",
        "name": "APS PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1497,
        "companyKind": "INSURER",
        "name": "GROUPE FILHET ALLARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1499,
        "companyKind": "INSURER",
        "name": "MUTUA GESTION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1500,
        "companyKind": "INSURER",
        "name": "UGIPS GESTION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1501,
        "companyKind": "INSURER",
        "name": "CIADE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1502,
        "companyKind": "INSURER",
        "searchNames": [
            "axelliance",
            "cipres assurance"
        ],
        "name": "ENTORIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1503,
        "companyKind": "INSURER",
        "name": "UNIASSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1508,
        "companyKind": "INSURER",
        "name": "PRAECONIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1509,
        "companyKind": "INSURER",
        "name": "ADEP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1513,
        "companyKind": "INSURER",
        "name": "AREAS ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1514,
        "companyKind": "INSURER",
        "name": "EXCLUSIVE HEALTHCARE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1516,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE GENERALE DE L'ECONOMIE DES FINANCES ET DE L'INDUSTRIE"
        ],
        "name": "MGEFI",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1517,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE NATIONALE DES FONCTIONNAIRES DES COLLECTIVITES TERRITORIALES"
        ],
        "name": "MNFCT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1518,
        "companyKind": "INSURER",
        "searchNames": [
            "Cocoon"
        ],
        "name": "GENERATION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1519,
        "companyKind": "INSURER",
        "name": "OCSO ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1520,
        "companyKind": "INSURER",
        "name": "MERCER",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1522,
        "companyKind": "INSURER",
        "searchNames": [
            "LEGAL & GENERAL"
        ],
        "name": "GRESHAM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1524,
        "companyKind": "INSURER",
        "name": "UNI SANTE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1529,
        "companyKind": "INSURER",
        "name": "DYNALIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1531,
        "companyKind": "INSURER",
        "name": "GROUPE AGRICA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1532,
        "companyKind": "INSURER",
        "searchNames": [
            "ASSUR O POIL",
            "TRANQUILLITE SANTE"
        ],
        "name": "HD ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1533,
        "companyKind": "INSURER",
        "name": "AMIS MALAKOFF MEDERIC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1534,
        "companyKind": "INSURER",
        "name": "UMANENS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1535,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE CONFEDERALE D'ASSURANCE DES BURALISTES DE FRANCE"
        ],
        "name": "MUDETAF",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1536,
        "companyKind": "INSURER",
        "searchNames": [
            "CENTRE DE PREVOYANCE MEDICO SOCIALE"
        ],
        "name": "CPMS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1539,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES PROFESSIONS JUDICIAIRES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1544,
        "companyKind": "INSURER",
        "searchNames": [
            "OCCIDENTALE DE CONSEIL ET DE GESTION"
        ],
        "name": "OCG",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1545,
        "companyKind": "INSURER",
        "name": "APRIL ENTREPRISE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1547,
        "companyKind": "INSURER",
        "searchNames": [
            "Assurances et Reassurances Inter Continentales"
        ],
        "name": "ARIC ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1549,
        "companyKind": "INSURER",
        "name": "GAN PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1552,
        "companyKind": "INSURER",
        "name": "COGEVIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1553,
        "companyKind": "INSURER",
        "name": "INTER MUTUELLES ENTREPRISES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1559,
        "companyKind": "INSURER",
        "searchNames": [
            "GROUPEMENT MILITAIRE DE PREVOYANCE DES ARMEES"
        ],
        "name": "GMPA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1561,
        "companyKind": "INSURER",
        "name": "MIS SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1562,
        "companyKind": "INSURER",
        "searchNames": [
            "mutuelle de prevoyance et de sante"
        ],
        "name": "MUTUELLE DE PREVOYANCE ET DE  SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1565,
        "companyKind": "INSURER",
        "name": "IPSEC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1567,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTAME NORMANDIE",
            "MUTAME VAL DE FRANCE",
            "MUTAME TERRITOIRE DE BELFORT"
        ],
        "name": "MUTAME & PLUS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1569,
        "companyKind": "INSURER",
        "name": "MUTUELLE MOS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1570,
        "companyKind": "INSURER",
        "searchNames": [
            "PREVOIR VIE GROUPE PREVOIR"
        ],
        "name": "PREVOIR VIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1573,
        "companyKind": "INSURER",
        "name": "LA MUTUELLE DU MEDECIN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1575,
        "companyKind": "INSURER",
        "name": "HARMONIE FONCTION PUBLIQUE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1577,
        "companyKind": "INSURER",
        "searchNames": [
            "Mutuelle du Personnel des Organismes Sociaux et Similaires region Midi-Pyrenees"
        ],
        "name": "MPOSS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1580,
        "companyKind": "INSURER",
        "name": "COLONNA FACILITY",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1581,
        "companyKind": "INSURER",
        "name": "ADOHA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1583,
        "companyKind": "INSURER",
        "name": "PREVOYANCE DIRECTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1584,
        "companyKind": "INSURER",
        "name": "FINANCIEL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1587,
        "companyKind": "INSURER",
        "searchNames": [
            "OCCITANE DE COURTAGE D'ASSURANCES"
        ],
        "name": "SOCA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1588,
        "companyKind": "INSURER",
        "searchNames": [
            "VIVINTER"
        ],
        "name": "SIACI SAINT HONORE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1591,
        "companyKind": "INSURER",
        "name": "SOCIETE D ASSURANCE MUTUELLE LA BRESSANE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1594,
        "companyKind": "INSURER",
        "name": "TUTELAIRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1595,
        "companyKind": "INSURER",
        "name": "La MEP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1596,
        "companyKind": "INSURER",
        "name": "GARANCE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1597,
        "companyKind": "INSURER",
        "name": "APRIL ENTREPRISE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1603,
        "companyKind": "INSURER",
        "searchNames": [
            "TNS ASSUR"
        ],
        "name": "GROUPE ROEDERER",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1612,
        "companyKind": "INSURER",
        "name": "COCOON",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1614,
        "companyKind": "INSURER",
        "searchNames": [
            "ASSURANCES MUTUELLES SAMBO"
        ],
        "name": "INIZYS MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1653,
        "companyKind": "INSURER",
        "searchNames": [
            "ASSURANCES BLANCHARD",
            "SOCIETE AIXOISE DE GESTION D'ASSURANCES"
        ],
        "name": "GROUPE SAGA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1694,
        "companyKind": "INSURER",
        "name": "MUTUELLE LE RALLIEMENT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1695,
        "companyKind": "INSURER",
        "name": "AMELLIS MUTUELLES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1702,
        "companyKind": "INSURER",
        "name": "UNION MUTUALITE SOLIDARITE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1708,
        "companyKind": "INSURER",
        "name": "MUTUELLE FAMILIALE DE L INDRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1710,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTUELLE INTER POLIET ET CIMENT FRANCAIS",
            "MIPCF"
        ],
        "name": "PLEYEL SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1711,
        "companyKind": "INSURER",
        "name": "MUTLOR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1712,
        "companyKind": "INSURER",
        "name": "MUTUELLE EUROPE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1719,
        "companyKind": "INSURER",
        "name": "MUTUELLE LA FRONTALIERE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1720,
        "companyKind": "INSURER",
        "name": "MUTUALP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1721,
        "companyKind": "INSURER",
        "name": "MUTUELLE UDT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1722,
        "companyKind": "INSURER",
        "name": "LA SOLIDARITE MUTUALISTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1723,
        "companyKind": "INSURER",
        "name": "LA MUTUELLE CATALANE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1743,
        "companyKind": "INSURER",
        "name": "MUTUALIA TERRITOIRES SOLIDAIRES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1744,
        "companyKind": "INSURER",
        "name": "CABINET LIGAP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1745,
        "companyKind": "INSURER",
        "name": "SFP - SOCIETE FRANCAISE DE PREVENTION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1746,
        "companyKind": "INSURER",
        "name": "MUTUELLE EPC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1766,
        "companyKind": "INSURER",
        "name": "MUTUELLE ENTRENOUS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1778,
        "companyKind": "INSURER",
        "name": "INSURED SERVICES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1781,
        "companyKind": "INSURER",
        "name": "MEDINAT - ALIANS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1792,
        "companyKind": "INSURER",
        "name": "MUTAME SAVOIE MONT-BLANC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1795,
        "companyKind": "INSURER",
        "name": "SOLIDARITE RURALE ET URBAINE D ALSACE - SORUAL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1801,
        "companyKind": "INSURER",
        "name": "MUTUELLE MGPA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1811,
        "companyKind": "INSURER",
        "name": "AUBEANE MUTUELLE DE FRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1814,
        "companyKind": "INSURER",
        "name": "MUTUELLE MMH",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1820,
        "companyKind": "INSURER",
        "name": "AIOSANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1829,
        "companyKind": "INSURER",
        "name": "BCC COURTAGE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1835,
        "companyKind": "INSURER",
        "name": "MUTUELLE LA FRANCE MARITIME",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1841,
        "companyKind": "INSURER",
        "name": "LAMIE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1847,
        "companyKind": "INSURER",
        "name": "MUTUELLE D ENTREPRISE 341",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1861,
        "companyKind": "INSURER",
        "name": "MUTUELLE MOAT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1873,
        "companyKind": "INSURER",
        "name": "SPVIE ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1885,
        "companyKind": "INSURER",
        "name": "ANIPS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1914,
        "companyKind": "INSURER",
        "name": "MCM CORSE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1919,
        "companyKind": "INSURER",
        "name": "PREVALOIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1943,
        "companyKind": "INSURER",
        "name": "FINAXY BANCASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1949,
        "companyKind": "INSURER",
        "searchNames": [
            "La Mutuelle Audiens",
            "Ancienne Mutuelle Audiens"
        ],
        "name": "UMEN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1959,
        "companyKind": "INSURER",
        "name": "MAT ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 1995,
        "companyKind": "INSURER",
        "name": "IZEHO GROUPE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2010,
        "companyKind": "INSURER",
        "name": "SMAVIE BTP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2016,
        "companyKind": "INSURER",
        "name": "MUTUELLE DE LA CORSE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2022,
        "companyKind": "INSURER",
        "name": "GROUPE CORIM ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2023,
        "companyKind": "INSURER",
        "searchNames": [
            "DAS"
        ],
        "name": "COVEA PROTECTION JURIDIQUE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2028,
        "companyKind": "INSURER",
        "searchNames": [
            "DOMBES BRESSE COURTAGE"
        ],
        "name": "ASSURANCE MUTUELLE VAL DE SAONE BEAUJOLAIS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2029,
        "companyKind": "INSURER",
        "name": "AUDIENS SANTE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2035,
        "companyKind": "INSURER",
        "name": "TERRITORIA MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2042,
        "companyKind": "INSURER",
        "searchNames": [
            "SMACEM",
            "SACEM"
        ],
        "name": "Societe Mutualiste des Auteurs Compositeurs et Editeurs de Musique",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2045,
        "companyKind": "INSURER",
        "searchNames": [
            "MAEE"
        ],
        "name": "MUTUELLE DES AFFAIRES ETRANGERES ET EUROPEENNES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2052,
        "companyKind": "INSURER",
        "name": "CDC MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2061,
        "companyKind": "INSURER",
        "name": "PROTECTION MUTUELLE ET FAMILALE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2064,
        "companyKind": "INSURER",
        "name": "SOLIDARM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2070,
        "companyKind": "INSURER",
        "searchNames": [
            "Mutuelle des cheminots de Lyon et Région"
        ],
        "name": "MCLR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2073,
        "companyKind": "INSURER",
        "searchNames": [
            "OLAM PARTNERS"
        ],
        "name": "MODULASSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2074,
        "companyKind": "INSURER",
        "searchNames": [
            "2MA"
        ],
        "name": "2MA - MA MEILLEURE ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2076,
        "companyKind": "INSURER",
        "searchNames": [
            "CYBELE",
            "CYBELE SOLIDARITE"
        ],
        "name": "MUTUELLE CYBELE SOLIDARITE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2079,
        "companyKind": "INSURER",
        "searchNames": [
            "CPAMIF"
        ],
        "name": "MUTUELLE PERSONNELS CPAMIF ORGAN SOCIAUX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2081,
        "companyKind": "INSURER",
        "searchNames": [
            "SPRING ASSUR"
        ],
        "name": "YOU ASSUR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2084,
        "companyKind": "INSURER",
        "searchNames": [
            "LMDB"
        ],
        "name": "LA MUTUELLE DE BAGNEAUX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2093,
        "companyKind": "INSURER",
        "name": "ASSUREA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2094,
        "companyKind": "INSURER",
        "name": "SURAVENIR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2101,
        "companyKind": "INSURER",
        "name": "SMERRA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2107,
        "companyKind": "INSURER",
        "name": "MUTUELLE MEUSREC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2108,
        "companyKind": "INSURER",
        "name": "MUTUELLE FRATERNELLE DES TERRITORIAUX",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2111,
        "companyKind": "INSURER",
        "name": "MUTUELLE DE L'ILE DE LA CITÉ",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2114,
        "companyKind": "INSURER",
        "name": "MUTUELLE BOISSIERE DU BATIMENT ET TP",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2117,
        "companyKind": "INSURER",
        "searchNames": [
            "GROUPE DES MUTUELLES INDEPENDANTES"
        ],
        "name": "GMI MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2126,
        "companyKind": "INSURER",
        "name": "CARPILIG PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2131,
        "companyKind": "INSURER",
        "searchNames": [
            "MCF"
        ],
        "name": "MUTUELLE DES CLINIQUES DE FRANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2137,
        "companyKind": "INSURER",
        "searchNames": [
            "Société Mutualiste Inter Entreprises"
        ],
        "name": "SMIE MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2140,
        "companyKind": "INSURER",
        "name": "ACTUDATA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2143,
        "companyKind": "INSURER",
        "name": "ALAN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2146,
        "companyKind": "INSURER",
        "searchNames": [
            "GROUPE C.R.P.",
            "C.R.P.",
            "CRP"
        ],
        "name": "CAISSE REUNIONNAISE DE PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2147,
        "companyKind": "INSURER",
        "name": "APIVIA COURTAGE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2150,
        "companyKind": "INSURER",
        "searchNames": [
            "ACPS BVR",
            "ASSOCIATION CONCEPT PREVOYANCE SANTE"
        ],
        "name": "ACPS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2151,
        "companyKind": "INSURER",
        "name": "Mutuelle SERAMM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2154,
        "companyKind": "INSURER",
        "searchNames": [
            "MUTA",
            "MUTA SANTE"
        ],
        "name": "MUTUALITE DE LA REUNION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2155,
        "companyKind": "INSURER",
        "name": "APRIL ENTREPRISE CARAIBES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2165,
        "companyKind": "INSURER",
        "searchNames": [
            "CAISSE INTERPROFESSIONNELLE DE",
            "PREVOYANCE"
        ],
        "name": "CIPREV",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2172,
        "companyKind": "INSURER",
        "name": "COVERITY",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2178,
        "companyKind": "INSURER",
        "name": "VITALITE SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2186,
        "companyKind": "INSURER",
        "name": "KIASSURE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2187,
        "companyKind": "INSURER",
        "name": "AESIO MUTUELLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2194,
        "companyKind": "INSURER",
        "name": "SOLIMUT MUTUELLE DU LACYDON",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2200,
        "companyKind": "INSURER",
        "name": "LOOMA ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2203,
        "companyKind": "INSURER",
        "name": "CF ASSURANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2206,
        "companyKind": "INSURER",
        "name": "CARDIF IARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2212,
        "companyKind": "INSURER",
        "name": "COMPLEVIE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2215,
        "companyKind": "INSURER",
        "name": "TEPEE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2218,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES SCOP ET DES SCIC",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2221,
        "companyKind": "INSURER",
        "name": "CARCEPT PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2230,
        "companyKind": "INSURER",
        "name": "MUTUELLE MARE GAILLARD",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2242,
        "companyKind": "INSURER",
        "name": "Mutuelle des Auteurs et Compositeurs Dramatiques",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2248,
        "companyKind": "INSURER",
        "name": "MUTUELLE DES PERES ET MERES DE FAMILLE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2262,
        "companyKind": "INSURER",
        "name": "MUTUELLE FAMILIALE DES TRAVAILLEURS DU GROUPE SAFRAN",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2268,
        "companyKind": "INSURER",
        "name": "ACHEEL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2271,
        "companyKind": "INSURER",
        "name": "ABELA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2292,
        "companyKind": "INSURER",
        "name": "HEMOS SANTE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2298,
        "companyKind": "INSURER",
        "name": "COLLECTEAM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2303,
        "companyKind": "INSURER",
        "name": "ASSUR TRAVEL",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2318,
        "companyKind": "INSURER",
        "name": "LA FRATERNELLE MUTUELLE INTERENTREPRISES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2321,
        "companyKind": "INSURER",
        "name": "SEYNA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2324,
        "companyKind": "INSURER",
        "name": "AS SOLUTIONS",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2326,
        "companyKind": "INSURER",
        "name": "OCEALIZ",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2338,
        "companyKind": "INSURER",
        "name": "MUTUELLE KEOLIS RENNES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2348,
        "companyKind": "INSURER",
        "name": "VHV Assurance France",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2368,
        "companyKind": "INSURER",
        "name": "MIAIMH",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2371,
        "companyKind": "INSURER",
        "name": "PRODIGEO ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2374,
        "companyKind": "INSURER",
        "name": "MFTSV",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2387,
        "companyKind": "INSURER",
        "name": "LOURMEL SOLUTIONS ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2429,
        "companyKind": "INSURER",
        "name": "KERIALIS PREVOYANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2457,
        "companyKind": "INSURER",
        "name": "IASSURE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2474,
        "companyKind": "INSURER",
        "name": "CORPORATE ASSISTANCE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2476,
        "companyKind": "INSURER",
        "name": "LA MUTUELLE DU GRAND PORT MARITIME DU HAVRE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2482,
        "companyKind": "INSURER",
        "name": "IKI ASSURANCES",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2483,
        "companyKind": "INSURER",
        "name": "MALMASSON COURTAGE",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2499,
        "companyKind": "INSURER",
        "name": "SOCIETE MUTUALISTE KSB et ESPA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2509,
        "companyKind": "INSURER",
        "name": "Caisse Nationale du Gendarme – Mutuelle de la Gendarmerie",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2512,
        "companyKind": "INSURER",
        "name": "Mutuelle Familiale de la Reunion - MFR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2515,
        "companyKind": "INSURER",
        "name": "Mutuelle du Personnel des Collectivités Territoriales - MPCTR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2518,
        "companyKind": "INSURER",
        "name": "Mutuelle Prevoyance et de l'Habitat de la Reunion - MPHR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2524,
        "companyKind": "INSURER",
        "name": "SELENCIA",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2527,
        "companyKind": "INSURER",
        "name": "MUTUELLE DU MONDE COMBATTANT",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2537,
        "companyKind": "INSURER",
        "name": "INSUREM",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2543,
        "companyKind": "INSURER",
        "name": "ASRAMA GESTION",
        "mandatOnly": false,
        "sendMethod": "LRE"
    },
    {
        "id": 2551,
        "companyKind": "INSURER",
        "name": "UMR",
        "mandatOnly": false,
        "sendMethod": "LRE"
    }
]